import axios from 'axios'
import _ from 'lodash'
import flat from 'flat'
import qs from 'query-string'
import core from '../core'

import { PATH } from './constants'

import { register } from './configs'

const { idColumns, valueTable } = register

const {
  constants: { API_URL }, //,
  helpers: { calculateAge, auth }
} = core

const getData = async (queries, names) => {
  const data = await Promise.all(queries)

  const register = data[0].data
  const persons = data[1].data
  const dataToMap = data[data.length - 1].data

  let dataMapped = {
    register,
    persons,
    data: dataToMap.map(r => {
      const registerEntry = _.find(register, ['id', r.registerId])
      const person = _.find(persons, ['id', registerEntry.personId])
      return {
        ...r,
        register: {
          ...registerEntry,
          person: {
            ...person
          }
        }
      }
    })
  }

  names.map((n, i) => {
    if (i > 1 && i < names.length)
      Object.assign(dataMapped, { [n]: data[i].data })
    return n
  })

  return dataMapped
}

const getCarePlanningData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/careplanning/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'careplanning'])

  return dataMapped
}

const getConsequencesData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/consequences/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'persons',
    'users',
    'consequences'
  ])

  return dataMapped
}

const getCommunicationsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/users/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/communications/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'persons',
    'users',
    'communications'
  ])

  return dataMapped
}

const getConsultationsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/consultations/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'consultations'])

  return dataMapped
}

const getDecisionsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/decisions/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'decisions'])

  return dataMapped
}

const getEventsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/events/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'events'])

  return dataMapped
}

const getPlacementPlansData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/placementplannings/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'persons',
    'placementplannings'
  ])

  return dataMapped
}

const getProfessionalAdvicesData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/advices/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'advices'])

  return dataMapped
}

const getRisksData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/risks/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, ['register', 'persons', 'risks'])

  return dataMapped
}

const getSignificantEventsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/significantevents/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'persons',
    'significantevents'
  ])

  return dataMapped
}

const getTrainingsData = async (
  recordId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  const queries = [
    axios.get(`${API_URL}/register/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/trainingnames/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/trainings/`, {
      headers: { authorization: auth(true) }
    })
  ]

  const dataMapped = getData(queries, [
    'register',
    'persons',
    'trainingnames',
    'trainings'
  ])

  return dataMapped
}

export const dataFunctions = {
  getCarePlanningData,
  getCommunicationsData,
  getConsequencesData,
  getConsultationsData,
  getDecisionsData,
  getEventsData,
  getPlacementPlansData,
  getProfessionalAdvicesData,
  getRisksData,
  getSignificantEventsData,
  getTrainingsData
}

export const getEnrichedRegister = async (
  registerId,
  filters,
  map = true,
  user = '',
  type = 'list'
) => {
  let queryString = {}
  let socialString = {}

  if (registerId && registerId !== 'new') queryString.id = registerId
  socialString.registerId = registerId
  //if (status) queryString.status = status
  //if (type) queryString.type = type
  // if ((await getUserRole()) !== 'admin') {
  //   queryString['audit.createdBy'] = sessionStorage.getItem('user')
  // } else {
  //   if (user && user !== '') queryString['audit.createdBy'] = user
  // }

  const queries = [
    axios.get(`${API_URL}/persons/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/centres/`, {
      headers: { authorization: auth(true) }
    }),
    axios.get(`${API_URL}/reasons/`, {
      headers: { authorization: auth(true) }
    }),
    // axios.get(`${API_URL}/socials/`, {
    //   headers: { authorization: auth(true) }
    // }), //?${qs.stringify(socialString)}`),
    axios.get(`${API_URL}${PATH}`, {
      headers: { authorization: auth(true) }
    })
  ]

  if (registerId !== 'new')
    queries.push(
      axios.get(
        `${API_URL}${PATH}${
          queryString.id //||
            ? // queryString.status ||
              // queryString.type ||
              // queryString['audit.createdBy']
              `?${qs.stringify(queryString)}`
            : ''
        }`,
        {
          headers: { authorization: auth(true) }
        }
      )
    )

  const data = await Promise.all(queries)

  const dataMapped = {
    persons: data[0].data,
    centres: data[1].data,
    reasons: data[2].data
    // socials: data[3].data
  }

  dataMapped.data =
    registerId !== 'new'
      ? map
        ? data[4].data.map(r =>
            enrichRegister(
              {
                ...r
              },
              dataMapped.persons,
              dataMapped.centres,
              dataMapped.reasons,
              [], // dataMapped.socials,
              type
            )
          )
        : data[4].data
      : []

  return dataMapped
}

export const enrichRegister = (
  entry,
  persons,
  centres,
  reasons,
  socials,
  type
) => {
  if (!entry) return {}
  const flatRegister = flat.flatten(entry)
  let enRegister = {}
  _.forOwn(flatRegister, (value, key) => {
    let object = {}
    switch (key) {
      case 'personId':
        object = _.find(persons, [`id`, value])
        if (object) {
          Object.assign(object, {
            fullName: `${object.firstName} ${object.lastName}`
          })
          Object.assign(object, {
            age: calculateAge(`${object.dob}`)
          })
          Object.assign(enRegister, { person: object })
        }
        break

      case 'placement.primaryReasonId':
        object = _.find(reasons, [`id`, value])
        if (object) {
          Object.assign(enRegister, { [`placement.primaryReason`]: object })
        }
        break

      case 'placement.admission.centreNameTo':
        object = _.find(centres, [`id`, parseInt(value, 10)])
        if (object) {
          Object.assign(enRegister, {
            [`placement.admission.centreNameTo`]: object
          })
        }
        break

      case _.find(idColumns, ['columnName', key])
        ? _.find(idColumns, ['columnName', key]).columnName
        : '':
        if (type === 'list') {
          object = _.find(
            valueTable[`${_.find(idColumns, ['columnName', key]).tableName}`],
            ['id', parseInt(value, 10)]
          )
          Object.assign(enRegister, {
            [`${key}`]: (object && object.label) || ''
          })
        } else {
          Object.assign(enRegister, { [`${key}`]: parseInt(value, 10) })
        }
        break

      // case _.includes(key, 'dates.') ? key : '':
      //   Object.assign(enRegister, { [`${key}`]: value })

      //   Object.assign(enRegister, { [`${key}Age`]: calculateAge(value) })
      //   if (key === 'dates.discharge') {
      //     Object.assign(enRegister, {
      //       [`dates.placementDuration`]: calculatePeriod(
      //         value,
      //         flatRegister[`dates.admission`]
      //       )
      //     })
      //   }
      // break

      default:
        Object.assign(enRegister, { [`${key}`]: value })
        break
    }
  })
  enRegister = flat.unflatten(enRegister)

  _.forOwn(enRegister, (value, key) => {
    if (_.isArray(value)) {
      //find most recent
      const mostRecent = _.orderBy(value, ['validFrom'], ['desc'])[0]
      if (
        type === 'list' &&
        (key !== 'social' &&
          key !== 'socialHistory' &&
          key !== 'personHistory') &&
        key !== 'notesHistory' &&
        key !== 'placementHistory'
      ) {
        const object = _.find(
          valueTable[`${_.find(idColumns, ['columnName', key]).tableName}`],
          [`id`, parseInt(mostRecent[`${key}Id`], 10)]
        )
        Object.assign(enRegister, {
          [`${key}`]: Object.assign(object, { validFrom: mostRecent.validFrom })
        })
      }

      if (key === 'social') {
        const object = _.find(socials, [`id`, parseInt(mostRecent[`id`], 10)])
        if (type === 'list') {
          const email = _.find(object.workerEmails, ['main', 1]) || ''
          const phone = _.find(object.workerPhones, ['main', 1]) || ''
          Object.assign(object, { ...object, workerEmails: email.email })
          Object.assign(object, { ...object, workerPhones: phone.phone })
          _.forOwn(object, (valueInner, keyInner) => {
            if (keyInner !== 'workerEmails' && keyInner !== 'workerPhones') {
              if (_.find(idColumns, ['columnName', keyInner])) {
                const objectInner = _.find(
                  valueTable[
                    `${_.find(idColumns, ['columnName', keyInner]).tableName}`
                  ],
                  ['id', parseInt(valueInner, 10)]
                )
                if (objectInner) {
                  Object.assign(object, { [`${keyInner}`]: objectInner.label })
                }
              }
            }
          })
          Object.assign(enRegister, { [`${key}`]: object })
        } else {
          Object.assign(enRegister, {
            [`${key}`]: _.orderBy(value, ['validFrom'], ['desc']).map(s =>
              _.find(socials, [`id`, parseInt(s[`id`], 10)])
            )
          })
        }
      }
    }
  })

  return enRegister
}



// WEBPACK FOOTER //
// ./src/register/helpers.js